import * as React from "react";
import type { SVGProps } from "react";
const SvgRadioOn = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m3.78-11.375.626-.781-1.562-1.25-.625.781-3.302 4.128-1.21-1.21L9 11.586 7.586 13l.707.707 2 2a1 1 0 0 0 1.488-.082z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgRadioOn;
